import React from 'react'

import { TIconProps } from '.'

const Table: React.FC<TIconProps> = ({ color, size }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-table"
    style={{ fill: 'transparent', width: size, height: size }}
  >
    <path
      d="M10 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V10M1 8H19M8 1V19M17 20.5C17.2053 19.6513 17.6406 18.8755 18.2581 18.2581C18.8755 17.6406 19.6513 17.2053 20.5 17C19.6513 16.7947 18.8755 16.3594 18.2581 15.7419C17.6406 15.1245 17.2053 14.3487 17 13.5C16.7947 14.3487 16.3594 15.1245 15.7419 15.7419C15.1245 16.3594 14.3487 16.7947 13.5 17C14.3487 17.2053 15.1245 17.6406 15.7419 18.2581C16.3594 18.8755 16.7947 19.6513 17 20.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Table
